import { format } from 'date-fns'

/**
 * Used to generate title for new set
 * @param city destination city
 * @param country destination country
 * @param date check-in date
 * @returns title like "City, Country 29 Nov" or "City 29 Nov" or "29 Nov"
 */
export const generateTitle = ({
	city,
	country,
	date
}: {
	city?: string
	country?: string
	date?: Date | number
}) =>
	`${city || country ? [city, country].join(', ') + ' ' : ''}${format(
		date ?? Date.now(),
		'dd MMM'
	)}`
